<template>
  <section class="sec-guests">
    <div class="module_title">
      <span class="en">{{ en }}</span>
      <span class="num" :class="`num_${index}`" />
      <span class="tit">嘉宾介绍</span>
      <span class="en">{{ en }}</span>
    </div>
    <div class="guests-main" v-show="data && data.length > 0">
      <div class="guests-bg" />
      <div class="guests-wrapper">
        <div class="float-bg" />
        <div class="swiper-container" ref="gtsMain">
          <ul class="swiper-wrapper">
            <li v-for="(item, index) in data" :key="index" class="swiper-slide">
              <img :src="item.img || IMG_LIST.GUESTS_DEFAULT_IMG" alt />
              <span class="guests-text" :title="item.text">{{ item.text }}</span>
            </li>
          </ul>
        </div>
        <div class="switch-arrow-left" ref="gtPrev" />
        <div class="switch-arrow-right" ref="gtNext" />
      </div>
    </div>
    <div class="guests-empty" v-show="data && data.length === 0">
      暂无数据
    </div>
  </section>
</template>
<script>
import Swiper from 'swiper/bundle'
import 'swiper/swiper-bundle.css'
import { IMG_LIST } from '../mock-data'

export default {
  data() {
    return {
      IMG_LIST,
      swiper: null,
    }
  },
  props: {
    index: {
      type: Number,
      default: 1,
    },
    data: {
      type: Array,
      default: () => [],
    },
    en: {
      type: String,
      default: '',
    },
  },
  methods: {
    initSwiper() {
      if (!this.swiper) {
        this.swiper = new Swiper(this.$refs.gtsMain, {
          observer: true,
          observeParents: true,
          observeSlideChildren: true,
          slidesPerView: 6,
          slidesPerGroup: 6,
          spaceBetween: 17,
          navigation: {
            nextEl: this.$refs.gtNext,
            prevEl: this.$refs.gtPrev,
          },
        })
      }
    },
  },
  mounted() {
    this.initSwiper()
  },
}
</script>
<style lang="less">
.carnival-module {
  .sec-guests {
    .float-bg {
      width: 322px;
      height: 153px;
      transform: rotate(-30deg);
      top: -200px;
      right: -50px;
    }
  }
}
.concert-module {
  .sec-guests {
    .float-bg {
      width: 322px;
      height: 153px;
      top: -200px;
      right: -50px;
    }
  }
}
.sec-guests {
  position: relative;
  .guests-empty {
    height: 208px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    font-size: 20px;
  }
  .guests-main {
    position: relative;
    z-index: 2;
    margin-top: 93px;
    margin-bottom: 72px;
    height: 208px;
    background: #2f15a2;
    background: linear-gradient(35deg, transparent 70px, #2f15a2 0);
    .guests-bg {
      position: absolute;
      top: 27px;
      left: 0;
      right: 0;
      bottom: 7px;
      background: #000000;
      background: linear-gradient(35deg, transparent 65px, #000000 0);
      &::before,
      &::after {
        display: inline-block;
        content: '';
        background-repeat: no-repeat;
        background-size: cover;
        position: absolute;
        top: 0;
        height: 174px;
      }
      &::before {
        width: 649px;
        left: 0;
        background-image: url('~@/assets/carnival2020/star_left.png');
      }
      &::after {
        width: 585px;
        right: 0;
        background-image: url('~@/assets/carnival2020/star_right.png');
      }
    }
  }

  .guests-wrapper {
    position: relative;
    max-width: 990px;
    margin: 0 auto;
  }

  .switch-arrow-left,
  .switch-arrow-right {
    top: 38px;
    width: 32px;
    height: 50px;
  }

  .switch-arrow-left {
    left: -40px;
  }

  .switch-arrow-right {
    right: -40px;
  }

  .swiper-container {
    top: -22px;
    width: 900px;
    ul {
      display: flex;
      li {
        flex-shrink: 0;
        width: 127px;
        height: 201px;
        overflow: hidden;
        position: relative;
        &::after {
          position: absolute;
          top: 0;
          left: 50%;
          transform: translateX(-50%);
          z-index: 1;
          display: block;
          content: '';
          width: 127px;
          height: 201px;
          background: url('~@/assets/carnival2020/guests_img.png') no-repeat top left;
          background-size: 100%;
        }
        img {
          position: absolute;
          top: 4px;
          left: 50%;
          transform: translateX(-50%);
          width: 117px;
          height: 145px;
          background-color: #7541ff;
        }
        .guests-text {
          position: absolute;
          bottom: 8px;
          left: 50%;
          transform: translateX(-50%);
          z-index: 2;
          text-align: center;
          width: 93px;
          font-size: 18px;
          font-family: HYYakuHei55W;
          color: #ffffff;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}
</style>
